import Spinner from "@/components/Spinner/Spinner"
import styles from "@/styles/components/Toggle.module.css"

/*
 * A labelled switch. Extracted alongside `Stepper`, for the same reason: the
 * lobby's exercise toggles and the in-session settings write the same config.
 *
 * `role="switch"` rather than a checkbox — this turns something on now, it does
 * not select a value to submit later.
 */

interface ToggleProps {
  label: string
  hint?: string
  checked: boolean
  disabled?: boolean
  /**
   * The write this switch started is still out.
   *
   * The switch throws the moment it is pressed — `checked` comes from the config
   * the listener has already applied locally — so without this it looks settled
   * while the round list it decides is still being written.
   */
  busy?: boolean
  onChange: (checked: boolean) => void
}

export default function Toggle({ label, hint, checked, disabled, busy, onChange }: ToggleProps) {
  return (
    <div className={styles.row}>
      <span className={styles.rowText}>
        <span className={styles.rowLabel}>{label}</span>
        {hint ? <span className={styles.hint}>{hint}</span> : null}
      </span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        disabled={disabled || busy}
        aria-busy={busy || undefined}
        className={checked ? `${styles.switch} ${styles.switchOn}` : styles.switch}
        onClick={() => onChange(!checked)}
      >
        {/* In place of the knob, at the knob's end of the track: the switch reads
            as mid-throw rather than as having lost its knob. */}
        {busy ? <Spinner className={styles.knobBusy} /> : <span className={styles.knob} />}
      </button>
    </div>
  )
}
